import ServiceSection from '@/components/landing/ServiceSection';

const TRADE_FEATURES = [
  'landing.services.trade.f1',
  'landing.services.trade.f2',
  'landing.services.trade.f3',
  'landing.services.trade.f4',
] as const;

// Услуги: единообразно (заголовок слева, композит-блок справа).
export default function ServiceCards() {
  return (
    <>
      <ServiceSection nsKey="trade" cover="service-trade-cover" featureKeys={TRADE_FEATURES} withCta />
      <ServiceSection nsKey="certification" cover="service-certification-cover" withCta />
    </>
  );
}
